import { useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL

const COLORES_NIVEL = {
  A1:'#22C55E', A2:'#3B82F6', B1:'#8B5CF6',
  B2:'#F59E0B', C1:'#EF4444', C2:'#1B3A8C'
}

// Textos bilingues de esta pantalla, controlados por el selector 🇪🇸 ES / 🇬🇧 EN
// que ya existe en la barra lateral del Dashboard.
const TEXTOS = {
  es: {
    definicion:'Definición:', ejemplos:'Ejemplos',
    volver:'← Volver', comoSeDice:'¿Cómo se dice en inglés?', tocaRespuesta:'Toca para ver la respuesta',
    traduccion:'Traducción', escuchar:'Escuchar 🔊', anterior:'Anterior', siguiente:'Siguiente', reiniciar:'Reiniciar 🔄',
    titulo:'Diccionario', subtitulo:'Busca palabras en español, guárdalas y repásalas con flashcards.',
    tabBuscar:'Buscar palabras', tabGuardadas:'Mis palabras',
    placeholder:'Busca una palabra en español o inglés...', buscando:'Buscando...',
    escribeMinimo:'Escribe al menos 2 letras para buscar', sinResultados:'No encontramos resultados para tu búsqueda',
    sinGuardadas:'No tienes palabras guardadas aún.', guardaConEstrella:'Busca palabras y guárdalas con el botón estrella',
    repasarFlashcards:'Repasar con flashcards 🃏',
    palabraGuardada:'Palabra guardada ⭐', palabraEliminada:'Palabra eliminada', errorGuardar:'Error al guardar'
  },
  en: {
    definicion:'Definition:', ejemplos:'Examples',
    volver:'← Back', comoSeDice:'How do you say this in English?', tocaRespuesta:'Tap to see the answer',
    traduccion:'Translation', escuchar:'Listen 🔊', anterior:'Previous', siguiente:'Next', reiniciar:'Restart 🔄',
    titulo:'Dictionary', subtitulo:'Search Spanish words, save them, and review them with flashcards.',
    tabBuscar:'Search words', tabGuardadas:'My words',
    placeholder:'Search for a word in Spanish or English...', buscando:'Searching...',
    escribeMinimo:'Type at least 2 letters to search', sinResultados:"We didn't find any results for your search",
    sinGuardadas:"You don't have any saved words yet.", guardaConEstrella:'Search for words and save them with the star button',
    repasarFlashcards:'Review with flashcards 🃏',
    palabraGuardada:'Word saved ⭐', palabraEliminada:'Word removed', errorGuardar:'Error saving'
  }
}

function hablar(texto) {
  if (!window.speechSynthesis) return
  window.speechSynthesis.cancel()
  const u = new SpeechSynthesisUtterance(texto)
  u.lang = 'es-CO'; u.rate = 0.85
  const voces = window.speechSynthesis.getVoices()
  const voz = voces.find(v => v.lang === 'es-CO') || voces.find(v => v.lang.startsWith('es'))
  if (voz) u.voice = voz
  window.speechSynthesis.speak(u)
}

function TarjetaPalabra({ item, guardadasIds, onGuardar, onEliminar, usuario, t }) {
  const [expandida, setExpandida] = useState(false)
  const estaGuardada = guardadasIds.includes(item.id)

  return (
    <div style={{ background:'#fff', border:'1.5px solid #E2E6F0', borderRadius:14, overflow:'hidden', boxShadow: expandida ? '0 4px 20px rgba(27,58,140,0.1)' : 'none' }}>
      <div style={{ padding:'16px 18px', cursor:'pointer', display:'flex', alignItems:'center', gap:12 }}
        onClick={() => setExpandida(e => !e)}>
        {item.nivel && (
          <span style={{ background:COLORES_NIVEL[item.nivel]||'#6B7280', color:'#fff', fontSize:10, fontWeight:800, padding:'2px 8px', borderRadius:999, flexShrink:0 }}>
            {item.nivel}
          </span>
        )}
        <div style={{ flex:1 }}>
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <span style={{ fontSize:16, fontWeight:700, color:'#1A1A2E' }}>{item.palabra}</span>
            {item.categoria && (
              <span style={{ fontSize:11, color:'#6B7280', background:'#F4F6FA', padding:'2px 8px', borderRadius:6 }}>
                {item.categoria}
              </span>
            )}
          </div>
          <div style={{ fontSize:13, color:'#6B7280', marginTop:2 }}>EN: {item.traduccion_en}</div>
        </div>
        <div style={{ display:'flex', gap:6, flexShrink:0 }}>
          <button onClick={e => { e.stopPropagation(); hablar(item.palabra) }}
            style={{ background:'#E8EFFE', border:'none', borderRadius:8, width:32, height:32, cursor:'pointer', fontSize:14, display:'flex', alignItems:'center', justifyContent:'center' }}>
            🔊
          </button>
          {usuario && (
            <button onClick={e => { e.stopPropagation(); estaGuardada ? onEliminar(item.id) : onGuardar(item.id) }}
              style={{ background: estaGuardada ? '#FEF0E0' : '#F4F6FA', border:'none', borderRadius:8, width:32, height:32, cursor:'pointer', fontSize:14, display:'flex', alignItems:'center', justifyContent:'center' }}>
              {estaGuardada ? '⭐' : '☆'}
            </button>
          )}
          <span style={{ color:'#9CA3AF', fontSize:12, display:'flex', alignItems:'center' }}>
            {expandida ? '▲' : '▼'}
          </span>
        </div>
      </div>
      {expandida && (
        <div style={{ borderTop:'1px solid #E2E6F0', padding:'14px 18px', background:'#FAFBFF' }}>
          <p style={{ fontSize:14, color:'#374151', marginBottom:12, lineHeight:1.6 }}>
            <strong>{t.definicion}</strong> {item.definicion}
          </p>
          {item.ejemplos?.length > 0 && (
            <div>
              <p style={{ fontSize:12, fontWeight:700, color:'#6B7280', marginBottom:8, textTransform:'uppercase' }}>{t.ejemplos}</p>
              <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                {item.ejemplos.map((ej, i) => (
                  <div key={i} style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:8, padding:'8px 12px' }}>
                    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                      <span style={{ fontSize:13, color:'#1A1A2E' }}>ES: {ej.es}</span>
                      <button onClick={() => hablar(ej.es)} style={{ background:'transparent', border:'none', cursor:'pointer', fontSize:13 }}>🔊</button>
                    </div>
                    <div style={{ fontSize:12, color:'#9CA3AF', fontStyle:'italic', marginTop:2 }}>EN: {ej.en}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default function Diccionario({ usuario, idioma = 'es' }) {
  const t = TEXTOS[idioma] || TEXTOS.es
  const [busqueda,        setBusqueda]        = useState('')
  const [resultados,      setResultados]      = useState([])
  const [guardadas,       setGuardadas]       = useState([])
  const [guardadasDetalle,setGuardadasDetalle]= useState([])
  const [vista,           setVista]           = useState('buscar')
  const [cargando,        setCargando]        = useState(false)
  const [mensaje,         setMensaje]         = useState(null)
  const [flashcard,       setFlashcard]       = useState(null)
  const [fcIndex,         setFcIndex]         = useState(0)
  const [fcVolteada,      setFcVolt]          = useState(false)

  useEffect(() => {
    if (usuario) cargarGuardadas()
  }, [usuario])

  useEffect(() => {
    if (busqueda.trim().length < 2) { setResultados([]); return }
    const timer = setTimeout(() => buscar(), 400)
    return () => clearTimeout(timer)
  }, [busqueda])

  async function buscar() {
    setCargando(true)
    try {
      const res = await axios.get(`${API}/curriculo/diccionario/buscar?q=${busqueda}`)
      setResultados(res.data.datos || [])
    } catch (err) { console.error(err) }
    finally { setCargando(false) }
  }

  async function cargarGuardadas() {
    try {
      const res = await axios.get(`${API}/curriculo/diccionario/guardadas/${usuario.id}`)
      const datos = res.data.datos || []
      // IDs para verificar si está guardada
      setGuardadas(datos.map(g => g.palabra_id).filter(Boolean))
      // Detalle completo de cada palabra guardada
      setGuardadasDetalle(datos.map(g => g.diccionario).filter(Boolean))
    } catch (err) { console.error(err) }
  }

  async function guardarPalabra(palabraId) {
    try {
      await axios.post(`${API}/curriculo/diccionario/guardar`, { usuario_id: usuario.id, palabra_id: palabraId })
      setMensaje({ tipo:'ok', texto: t.palabraGuardada })
      cargarGuardadas()
    } catch (err) {
      setMensaje({ tipo:'error', texto: err.response?.data?.error || t.errorGuardar })
    }
    setTimeout(() => setMensaje(null), 2500)
  }

  async function eliminarPalabra(palabraId) {
    try {
      await axios.delete(`${API}/curriculo/diccionario/eliminar`, { data: { usuario_id: usuario.id, palabra_id: palabraId } })
      setMensaje({ tipo:'ok', texto: t.palabraEliminada })
      cargarGuardadas()
    } catch (err) { console.error(err) }
    setTimeout(() => setMensaje(null), 2500)
  }

  function iniciarFlashcards() {
    if (guardadasDetalle.length === 0) return
    setFcIndex(0); setFcVolt(false)
    setFlashcard(guardadasDetalle)
    setVista('flashcards')
  }

  if (vista === 'flashcards' && flashcard) {
    const palabra = flashcard[fcIndex]
    return (
      <div style={{ maxWidth:600, margin:'0 auto', animation:'fadeIn .3s ease both' }}>
        <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:24 }}>
          <button onClick={() => setVista('guardadas')}
            style={{ background:'none', border:'none', cursor:'pointer', fontSize:13, color:'#6B7280', fontFamily:'inherit' }}>
            {t.volver}
          </button>
          <h2 style={{ fontSize:20, fontWeight:800, color:'#1A1A2E' }}>Flashcards</h2>
          <span style={{ marginLeft:'auto', fontSize:13, color:'#6B7280' }}>{fcIndex+1} / {flashcard.length}</span>
        </div>
        <div style={{ height:4, background:'#E2E6F0', borderRadius:999, marginBottom:24, overflow:'hidden' }}>
          <div style={{ width:`${((fcIndex+1)/flashcard.length)*100}%`, height:'100%', background:'#1B3A8C', borderRadius:999, transition:'width .4s' }} />
        </div>
        <div onClick={() => setFcVolt(v => !v)}
          style={{ background: fcVolteada ? 'linear-gradient(135deg,#1B3A8C,#0D1F52)' : 'linear-gradient(135deg,#F4F6FA,#fff)',
            border:'2px solid #E2E6F0', borderRadius:20, padding:48, textAlign:'center', cursor:'pointer',
            minHeight:220, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:12,
            transition:'all .3s', boxShadow:'0 8px 32px rgba(27,58,140,0.12)' }}>
          {!fcVolteada ? (
            <>
              <div style={{ fontSize:13, color:'#6B7280', marginBottom:8 }}>{t.comoSeDice}</div>
              <div style={{ fontSize:36, fontWeight:900, color:'#1A1A2E' }}>{palabra.palabra}</div>
              {palabra.categoria && <div style={{ fontSize:12, color:'#9CA3AF' }}>{palabra.categoria}</div>}
              <div style={{ fontSize:12, color:'#9CA3AF', marginTop:8 }}>{t.tocaRespuesta}</div>
            </>
          ) : (
            <>
              <div style={{ fontSize:13, color:'rgba(255,255,255,0.6)', marginBottom:8 }}>{t.traduccion}</div>
              <div style={{ fontSize:32, fontWeight:900, color:'#FFD700' }}>{palabra.traduccion_en}</div>
              <div style={{ fontSize:14, color:'rgba(255,255,255,0.8)', marginTop:8, maxWidth:300 }}>{palabra.definicion}</div>
              <button onClick={e => { e.stopPropagation(); hablar(palabra.palabra) }}
                style={{ marginTop:8, background:'rgba(255,255,255,0.15)', border:'1px solid rgba(255,255,255,0.3)', borderRadius:8, padding:'6px 14px', color:'#fff', fontSize:13, cursor:'pointer' }}>
                {t.escuchar}
              </button>
            </>
          )}
        </div>
        <div style={{ display:'flex', justifyContent:'center', gap:12, marginTop:24 }}>
          <button disabled={fcIndex === 0} onClick={() => { setFcIndex(i => i-1); setFcVolt(false) }}
            style={{ padding:'10px 24px', background: fcIndex===0 ? '#E2E6F0' : '#fff', color: fcIndex===0 ? '#9CA3AF' : '#1B3A8C', border:'1.5px solid #E2E6F0', borderRadius:10, fontFamily:'inherit', fontSize:14, fontWeight:600, cursor: fcIndex===0 ? 'not-allowed' : 'pointer' }}>
            {t.anterior}
          </button>
          {fcIndex < flashcard.length - 1 ? (
            <button onClick={() => { setFcIndex(i => i+1); setFcVolt(false) }}
              style={{ padding:'10px 24px', background:'#1B3A8C', color:'#fff', border:'none', borderRadius:10, fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
              {t.siguiente}
            </button>
          ) : (
            <button onClick={() => { setFcIndex(0); setFcVolt(false) }}
              style={{ padding:'10px 24px', background:'#22C55E', color:'#fff', border:'none', borderRadius:10, fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
              {t.reiniciar}
            </button>
          )}
        </div>
      </div>
    )
  }

  return (
    <div style={{ maxWidth:900, margin:'0 auto', animation:'fadeIn .3s ease both' }}>
      <div style={{ marginBottom:24 }}>
        <h1 style={{ fontSize:24, fontWeight:800, color:'#1A1A2E', marginBottom:4 }}>{t.titulo}</h1>
        <p style={{ fontSize:14, color:'#6B7280' }}>{t.subtitulo}</p>
      </div>

      {mensaje && (
        <div style={{ padding:'10px 16px', borderRadius:10, marginBottom:16, fontSize:14, fontWeight:600,
          background: mensaje.tipo==='ok' ? '#F0FDF4' : '#FEF2F2',
          color: mensaje.tipo==='ok' ? '#166534' : '#991B1B',
          border:`1px solid ${mensaje.tipo==='ok' ? '#22C55E' : '#EF4444'}` }}>
          {mensaje.texto}
        </div>
      )}

      <div style={{ display:'flex', gap:8, marginBottom:24 }}>
        {[
          { id:'buscar',    label: t.tabBuscar },
          { id:'guardadas', label: t.tabGuardadas + ' (' + guardadasDetalle.length + ')' },
        ].map(tab => (
          <button key={tab.id} onClick={() => setVista(tab.id)}
            style={{ padding:'8px 18px', borderRadius:999, border:'2px solid ' + (vista===tab.id ? '#1B3A8C' : '#E2E6F0'),
              background: vista===tab.id ? '#1B3A8C' : '#fff', color: vista===tab.id ? '#fff' : '#374151',
              fontFamily:'inherit', fontSize:13, fontWeight:600, cursor:'pointer' }}>
            {tab.label}
          </button>
        ))}
      </div>

      {vista === 'buscar' && (
        <div>
          <div style={{ position:'relative', marginBottom:20 }}>
            <input value={busqueda} onChange={e => setBusqueda(e.target.value)}
              placeholder={t.placeholder}
              style={{ width:'100%', padding:'12px 14px', border:'1.5px solid #E2E6F0', borderRadius:12, fontFamily:'inherit', fontSize:15, outline:'none', boxSizing:'border-box' }}
            />
            {cargando && <span style={{ position:'absolute', right:14, top:'50%', transform:'translateY(-50%)', color:'#6B7280', fontSize:12 }}>{t.buscando}</span>}
          </div>
          {busqueda.length < 2 && (
            <div style={{ textAlign:'center', padding:40, color:'#9CA3AF' }}>
              <div style={{ fontSize:48, marginBottom:12 }}>📖</div>
              <p>{t.escribeMinimo}</p>
            </div>
          )}
          {busqueda.length >= 2 && resultados.length === 0 && !cargando && (
            <div style={{ textAlign:'center', padding:40, color:'#9CA3AF' }}>
              <div style={{ fontSize:48, marginBottom:12 }}>🤷</div>
              <p>{t.sinResultados}</p>
            </div>
          )}
          <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
            {resultados.map(item => (
              <TarjetaPalabra key={item.id} item={item}
                guardadasIds={guardadas}
                onGuardar={guardarPalabra} onEliminar={eliminarPalabra} usuario={usuario} t={t} />
            ))}
          </div>
        </div>
      )}

      {vista === 'guardadas' && (
        <div>
          {guardadasDetalle.length === 0 ? (
            <div style={{ textAlign:'center', padding:60, color:'#9CA3AF' }}>
              <div style={{ fontSize:48, marginBottom:12 }}>⭐</div>
              <p style={{ fontSize:16 }}>{t.sinGuardadas}</p>
              <p style={{ fontSize:13, marginTop:4 }}>{t.guardaConEstrella}</p>
            </div>
          ) : (
            <>
              <div style={{ display:'flex', justifyContent:'flex-end', marginBottom:16 }}>
                <button onClick={iniciarFlashcards}
                  style={{ background:'#F07C1E', color:'#fff', border:'none', borderRadius:10, padding:'10px 20px', fontFamily:'inherit', fontSize:14, fontWeight:700, cursor:'pointer' }}>
                  {t.repasarFlashcards}
                </button>
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                {guardadasDetalle.map(item => (
                  <TarjetaPalabra key={item.id} item={item}
                    guardadasIds={guardadas}
                    onGuardar={guardarPalabra} onEliminar={eliminarPalabra} usuario={usuario} t={t} />
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  )
}
